export const LOADER_START = "<!-- m8t:brain-loader:start -->";
export const LOADER_END = "<!-- m8t:brain-loader:end -->";
// Matches a LEGACY (pre-marker) loader by its distinctive opening (from
// targets/foundry/brain-loader.md) — far less likely to false-match a persona
// that merely uses "## Your second brain" as a heading.
const LEGACY_HEADER = "## Your second brain\n\nYou have a persistent second brain:";

/** Remove a previously-appended brain loader (marked or legacy) from instructions. */
export function stripBrainLoader(instructions: string): string {
  const s = instructions.indexOf(LOADER_START);
  if (s !== -1) {
    const e = instructions.indexOf(LOADER_END, s);
    const head = instructions.slice(0, s);
    const tail = e !== -1 ? instructions.slice(e + LOADER_END.length) : "";
    return (head + tail).replace(/\s+$/, "");
  }
  const h = instructions.lastIndexOf(LEGACY_HEADER);
  if (h !== -1) return instructions.slice(0, h).replace(/\s+$/, "");
  return instructions.replace(/\s+$/, "");
}

/** Strip any prior loader, then append `loaderText` wrapped in idempotency markers. */
export function appendBrainLoader(base: string, loaderText: string): string {
  const clean = stripBrainLoader(base);
  return `${clean}\n\n${LOADER_START}\n${loaderText.replace(/\s+$/, "")}\n${LOADER_END}\n`;
}
